import React from 'react';
import axios from 'axios';
import { CoborrowerForm } from '..';
import {  COLLATERAL_URL, CAR_URL } from '../../../../../config';
import CoborrowersList from './CoborrowersList';
import Button from '../../../Common/Button';
import { getFormURL } from '../../../../../utils';
import { TOP_LEVEL_PREFIX } from '../../../../../config';


export default class CoborrowerStaffFormContainer extends React.Component {
    state = {
        coborrowers: [],
        coborrower: {
            first_name: '',
            last_name: '',
            dni: '',
            relation: null,
            occupation: '',
            civil_status: null,
            incomes: [],
            number: '',
        },
        newIncome: {
            income_type: null,
            category: null,
            income:  '',
            seniority: null,
        },
        errors: {
            newIncome: {},
        },
        isEditing: false,
    };


    componentDidMount() {
        axios.get('/api/v2/coborrowers/')
            .then(({ data }) => {
                this.setState({
                    coborrowers: data.results,
                });
            })
    }

    coborrowerSubmit = (coborrower, income) => {
        this.setState({
            newIncome: income,
            coborrower: coborrower,
            errors: {
                newIncome: {},
            },
        });
        this.postCoborrowerInfo(coborrower)
            .then((id) => this.postCoborrowerIncome(income, id))
            .catch(({ response }) =>  {
                const errors = {}
                Object.keys(response.data).forEach(field => {
                    errors[field] = response.data[field]
                });
                this.setState({
                    errors: {
                        ...this.state.errors,
                        ...errors,
                    }
                });
            });
    }

    postCoborrowerInfo = coborrower => {
        if (!coborrower.number) {
            return axios.post(`/api/v2/coborrowers/`, coborrower)
                .then(res => res.data)
                .then(coborrower => {
                    this.setState({ coborrower })
                    return coborrower.number
                });
        }
        return Promise.resolve(coborrower.number);
    }

    postCoborrowerIncome = (income, id) =>
        axios.post(`/api/v2/coborrowers/${id}/incomes/`, income)
            .then(res => res.data)
            .then((income) => {
                this.setState({
                    status: income.status,
                    coborrower: {
                        ...this.state.coborrower,
                        incomes: [...this.state.coborrower.incomes, income],
                    },
                    newIncome: {
                        income_type: '',
                        category: '',
                        income:  '',
                        seniority: '',
                    },
                });
            })
            .catch(({ response }) =>  {
                const errors = {}
                Object.keys(response.data).forEach(field => {
                    errors[field] = response.data[field]
                });
                this.setState({
                    errors: {
                        ...this.state.errors,
                        newIncome: errors,
                    }
                });
            });


    postCoborrowerForm = (coborrower) => {
        this.setState({
            errors: {
                newIncome: {},
            },
        });
        if (this.props.with_coborrower) {
            this.editCoborrower(coborrower)
                .then(() => {
                    this.setState({
                        coborrowers: [...this.state.coborrowers, coborrower],
                        coborrower: {
                            first_name: '',
                            last_name: '',
                            dni: '',
                            relation: null,
                            occupation: '',
                            civil_status: null,
                            incomes: [],
                        },
                    })
                })
                .catch(({ response }) =>  {
                    const errors = {}
                    Object.keys(response.data).forEach(field => {
                        errors[field] = response.data[field]
                    });
                    this.setState({
                        errors: {
                            ...this.state.errors,
                            ...errors,
                        }
                    });
                });
        } else {
            axios.delete('/api/v2/coborrower/')
                .then(() => {
                    if (this.props.apptype === 'hd') {
                        this.props.history.push(`${TOP_LEVEL_PREFIX}${getFormURL(this.props.match.params.apptype)}${COLLATERAL_URL}`);
                    }else{
                        this.props.history.push(`${TOP_LEVEL_PREFIX}${getFormURL(this.props.match.params.apptype)}${CAR_URL}`);
                    }
                })
        }
    }

    deleteIncome = (id) => {
        axios.delete(`/api/v2/coborrowers/${this.state.coborrower.number}/incomes/${id}/`)
            .then(() => {
                this.setState({
                    coborrower: {
                        ...this.state.coborrower,
                        incomes: this.state.coborrower.incomes.filter(income => income.number !== Number(id)),
                    },
                });
            });
    }

    goToCollateral = () => {
        axios.get(`/api/v2/coborrowers/update_status/`);
        if (this.props.apptype === 'hd') {
            this.props.history.push(`${this.props.chatUrl}${COLLATERAL_URL}`);
        }else{
            this.props.history.push(`${this.props.chatUrl}${CAR_URL}`);
        }
    }

    editIncome = (number, income) => {
        return axios.put(`/api/v2/coborrowers/${this.state.coborrower.number}/incomes/${number}/`, income)
            .then(({ data }) => {
                this.setState({
                    coborrower: {
                        ...this.state.coborrower,
                        incomes: this.state.coborrower.incomes.map((income) => {
                            if (income.number === data.number) return data;
                            return income;
                        }),
                    },
                });
            });
    }

    editCoborrower = coborrower =>
        axios.put(`/api/v2/coborrowers/${this.state.coborrower.number}/`, coborrower)
            .then(({ data }) => {
                this.setState({
                    coborrowers: this.state.coborrowers.map(coborrower => coborrower.number === data.number ? data : coborrower),
                    coborrower: {
                        first_name: '',
                        last_name: '',
                        dni: '',
                        relation: null,
                        occupation: '',
                        civil_status: null,
                        incomes: [],
                        number: '',
                    },
                    isEditing: false,
                })
            })
            .catch(({ response }) =>  {
                const errors = {}
                Object.keys(response.data).forEach(field => {
                    errors[field] = response.data[field]
                });
                this.setState({
                    errors: {
                        ...this.state.errors,
                        ...errors,
                    }
                });
            });

    deleteCoborrower = number =>
        axios.delete(`/api/v2/coborrowers/${number}/`)
            .then(() => this.setState({ coborrowers: this.state.coborrowers.filter(coborrower => coborrower.number !== number) }))

    selectCoborrower = number => this.setState({ coborrower: this.state.coborrowers.find(coborrower => coborrower.number === number), isEditing: true });

    cleanCoborrower = () => this.setState({
        coborrower: {
            first_name: '',
            last_name: '',
            dni: '',
            relation: null,
            occupation: '',
            civil_status: null,
            incomes: [],
            number: '',
        },
        isEditing: false,
    })


    render() {
        const { errors, newIncome, coborrower, thereismore, coborrowers, isEditing } = this.state;
        const { match, with_coborrower, changeWithCoborrower, apptype} = this.props;
        return (
            <div>
                <CoborrowersList
                    coborrowers={coborrowers}
                    selectCoborrower={this.selectCoborrower}
                    deleteCoborrower={this.deleteCoborrower}
                    addCoborrower={this.cleanCoborrower}
                    isEditing={isEditing}
                />
                <CoborrowerForm
                    postCoborrowerForm={isEditing ? this.editCoborrower : this.postCoborrowerForm}
                    errors={errors}
                    deleteIncome={this.deleteIncome}
                    coborrowerSubmit={this.coborrowerSubmit}
                    newIncome={newIncome}
                    match={match}
                    editIncome={this.editIncome}
                    values={coborrower}
                    with_coborrower={with_coborrower}
                    changeWithCoborrower={changeWithCoborrower}
                    apptype={apptype}
                />
                {!isEditing && !!coborrowers.length && <Button onClick={this.goToCollateral}>Ir al siguiente Formulario</Button>}
            </div>
        );
    }
}
